import "vite/modulepreload-polyfill";
import { lazy } from "react";
import IslandCompoundWrapper from "./components/IslandCompoundWrapper";
import { registerReactComponent } from "./helper";

const SaleBasket = lazy(() => import("./islands/SaleBasket"));
const SaleFavourites = lazy(() => import("./islands/SaleFavourites"));

console.log("[React] Message from React");

registerReactComponent(
  "RSaleBasket",
  <IslandCompoundWrapper
    component={<SaleBasket params={window.RSaleBasket} />}
  />,
);

registerReactComponent(
  "RSaleFavourites",
  <IslandCompoundWrapper
    component={<SaleFavourites params={window.RSaleFavourites} />}
  />,
);
